import { ref } from "vue";

/**
 * Whether the current user belongs to a team flagged as a demo team.
 * Used to gate demo-team-only UI such as the workspace clone affordances
 * in the sidebar.
 */
export const isDemoTeam = ref(false);

/**
 * Whether the current user has the team-admin role on their team. The
 * role is generalised to all teams (not just demo); the team-management
 * UI is currently only surfaced to demo teams as a separate gate.
 */
export const isTeamAdmin = ref(false);

/**
 * The current user's team id, if any. Mirrors `users/{uid}.team`.
 * Used by client-side guards on `/teams/:teamId/manage` and the like.
 */
export const currentTeamId = ref<string | null | undefined>(undefined);

/**
 * The display name of the current user's team, if any. Mirrors
 * `teams/{id}.name` and is hydrated alongside the other team fields in
 * userst.ts. Surfaced in the sidebar so members can see which team they
 * belong to without needing to open the team management page.
 */
export const currentTeamName = ref<string | null>(null);

/**
 * Whether the current user belongs to a team flagged as an automation team.
 * When true, downstream UI (e.g. NewProtocolPage) enforces config selection.
 */
export const isAutomationTeam = ref(false);

/**
 * Demo template workspace ids configured on the current user's team.
 * Mirrors `teams/{id}.templateWorkspaceIds`. Drives visibility of the
 * "Clone a demo template…" sidebar button (hidden when empty).
 */
export const teamTemplateWorkspaceIds = ref<string[]>([]);
